import { commonSemanticActionLabels } from "./common-actions";

export const platformAdminValues = {
  semanticActions: {
    authorize: "授权",
    viewBindings: "权限绑定",
    viewCatalog: "角色目录",
    viewSnapshot: "成员摘要",
    manageCredentials: "接入凭证",
    openDirectorWorkspace: "打开导演工作台",
    openJudgeWorkspace: "打开裁判工作台",
    openReviewWorkspace: "打开复核工作台",
    generate: commonSemanticActionLabels.generate,
    configure: commonSemanticActionLabels.configure,
    commit: commonSemanticActionLabels.commit,
    rejudge: "重判",
    instantiate: "实例化",
    compare: commonSemanticActionLabels.compare,
    resetPassword: commonSemanticActionLabels.resetPassword,
    unlock: commonSemanticActionLabels.unlock,
    lock: commonSemanticActionLabels.lock,
    impersonate: "代入用户",
    kickout: "踢下线",
    customFields: "自定义字段",
    openConsole: "打开控制台",
    openVnc: "打开 VNC",
    extend: commonSemanticActionLabels.extend,
    destroy: commonSemanticActionLabels.destroy,
    viewTask: "查看任务",
    heartbeat: "心跳快照",
    adoptVm: "纳管虚机",
    releaseVm: "脱管虚机",
  },
} as const;
